import {createLazyOcticon} from './create-lazy-octicon'
import {octiconsMap} from './lazy-octicons-map'

// eslint-disable-next-line no-barrel-files/no-barrel-files -- the same facade for server and client exports
export type {LazyOcticonName, LazyOcticonProps, OcticonsMap} from './create-lazy-octicon'

/**
 * Client build of the LazyOcticon API. Each icon is code-split into its own
 * chunk (see `lazy-octicons-map.ts`) and fetched on demand. Alloy SSR resolves
 * the synchronous server build instead via the package's `node` export condition
 * (see `LazyOcticon.server.tsx`).
 */
export const {LazyOcticon, isLazyOcticonName, octiconComponent} = createLazyOcticon(octiconsMap)
